import { createBrowserRouter, Outlet } from 'react-router-dom'

import { ChatPage } from './features/chat/ChatPage'
import { Dashboard } from './features/dashboard/Dashboard'
import { ResourcesLibrary } from './features/library/ResourcesLibrary'
import { ScheduledSessions } from './features/manager/schedules-sessions/ScheduledSessions'
import { CalendarConnect } from './features/onboarding/calendar-connect/CalendarConnect'
import { GoogleConnect } from './features/onboarding/google-connect/GoogleConnect'
import { WhatWeDo } from './features/onboarding/what-we-do/WhatWeDo'
import { TeamMembersPage } from './features/team-member/TeamMembersPage'
import { MainLayout } from './layout/main/MainLayout'
import { OnboardingLayout } from './layout/onboarding/OnboardingLayout'
import InAppMeeting from './features/dashboard/meeting/InAppMeeting'
import { ProgressPage } from './features/progress/ProgressPage'
import { LoginPage } from './features/login/LoginPage'
import { AssessmentRedirect } from './features/assessment/AssessmentRedirect'
import { AssessmentItem } from './features/assessment/AssessmentItem'
import { CoachSelection } from './features/onboarding/coach-selection/CoachSelection'
import { NotesPage } from './features/notes/NotesPage'
import { PeerAssessmentPage } from './features/peer-assessment/PeerAssessmentPage'
import { Settings } from './features/settings/Settings'
import HupoHighlightsEdit from './features/hupohighlights/HupoHighlightsEdit'
import HupoHighlightsEditSuccess from './features/hupohighlights/HupoHighlightsEditSuccess'
import HupoHighlightsVerify from './features/hupohighlights/HupoHighlightsVerify'
import { NotFound } from './not-found'
import { ErrorPage } from './error-page'
import { ForgotPassword } from './features/login/ForgotPassword'
import { ResetPassword } from './features/login/ResetPassword'
import PostSessionFeedbackPage from './features/feedback/PostSessionFeedbackPage'

const GenerateError = () => {
  throw new Error('Random error occurred')
  return <></>
}

export const routes = createBrowserRouter([
  {
    element: <Outlet />,
    errorElement: <ErrorPage />,
    children: [
      //#region Onboarding
      {
        path: '/onboarding',
        element: <OnboardingLayout />,
        children: [
          {
            index: true,
            element: <WhatWeDo />,
          },
          {
            path: 'getting-to-know',
            element: <GoogleConnect />,
          },
          {
            path: 'connect-calendar',
            element: <CalendarConnect />,
          },
          {
            path: 'coach-selection',
            element: <CoachSelection />,
          },
        ],
      },
      //#endregion
      //#region Assessment
      {
        path: '/assessment',
        element: <AssessmentRedirect />,
        children: [
          {
            path: ':friendlyId',
            element: <AssessmentItem />,
          },
        ],
      },
      //#endregion
      //#region In-App Meeting
      {
        path: '/meeting/:sessionId/:participantId',
        // access participantId and sessionId from params
        element: <InAppMeeting />,
      },
      //#endregion
      //#region Login
      {
        path: '/login',
        element: <LoginPage />,
      },
      {
        path: '/forgot-password',
        element: <ForgotPassword />,
      },
      {
        path: '/password_reset',
        children: [
          {
            path: ':token/:email',
            element: <ResetPassword />,
          },
        ],
      },
      //#endregion
      //#region Post session feedback
      {
        path: '/session-feedback/:sessionId/:participantId',
        element: <PostSessionFeedbackPage />,
      },
      //#endregion
      //#region Peer Assessment
      {
        path: '/peer-assessment',
        element: <PeerAssessmentPage />,
      },
      //#endregion
      //#region Session summary edit/verify
      {
        path: '/coach/:id/session-summary',
        children: [
          {
            path: 'verify/:sessionId',
            element: <HupoHighlightsVerify />,
          },
          {
            path: 'edit/:sessionId',
            element: <HupoHighlightsEdit />,
          },
          {
            path: 'edit-success',
            element: <HupoHighlightsEditSuccess />,
          },
        ],
      },
      //#endregion
      //#region Dashboard
      {
        path: '/',
        element: <MainLayout />,
        children: [
          {
            index: true,
            element: <Dashboard />,
          },
          {
            path: 'team-members',
            element: <TeamMembersPage />,
          },
          {
            path: 'scheduled-sessions',
            element: <ScheduledSessions />,
          },
          {
            path: 'progress',
            element: <ProgressPage />,
          },
          {
            path: 'team-chat',
            element: <ChatPage />,
            children: [
              {
                path: ':id',
                element: <ChatPage />,
              },
            ],
          },
          {
            path: 'resources',
            element: <ResourcesLibrary />,
          },
          {
            path: 'settings/:tabId',
            element: <Settings />,
          },
          {
            path: 'notes',
            element: <NotesPage />,
          },
        ],
      },
      //#endregion

      {
        path: '/random-error-occurrs-when-you-visit-this-path',
        element: <GenerateError />,
      },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
])
